module.exports = __webpack_public_path__ + "img/alert.2713bf7f.svg";